/* udp-container-query-grid.css */
:host {
  display: block;
  width: 100%;
}

.grid-container {
  width: 100%;
}